/*                                     */
/**
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/**
 *
 */
export const apm = /*           */ asExport(otto, "apm", {});
/**
 *
 *
 *
 */
export const agent = /*           */ asExport(apm, "agent", noop);
/**
 *
 *
 *
 *
 */
export const isActive = /*           */ asExport(apm, "isActive", noop);
/**
 *
 *
 *
 */
export const getCurrentTransaction = /*           */ asExport(apm, "getCurrentTransaction", noop);
/**
 *
 *
 *
 */
export const startSpan = /*           */ asExport(apm, "startSpan", noop);
/**
 *
 *
 *
 *
 */
export const captureError = /*           */ asExport(apm, "captureError", noop);
/**
 *
 *
 *
 */
export const mark = /*           */ asExport(apm, "mark", noop);
/**
 *
 *
 *
 */
export const addLabels = /*           */ asExport(apm, "addLabels", noop);
/**
 *
 */
export const sendCustomError = /*           */ asExport(apm, "sendCustomError", noop);
/**
 *
 */
export const apmSync = /*           */ asExport(o_util, "apm", {});
/**
 *
 *
 *
 */
export const runWithSpan = /*           */ asExport(apmSync, "runWithSpan", noop);
/**
 *
 *
 *
 */
export const withSpan = /*           */ asExport(apmSync, "withSpan", noop);
